import { Question } from '@mom/shared';
import { SurveyType } from '@mom/shared/data';

export class ProjectSurveyContent {
  externalProjectId: string;
  description: string;
  shortDescription: string;
  questions?: Question[];
  surveyUrl?: string;
  notepadJson?: string;
  surveyJson?: string;
  surveyTypeId: SurveyType;
  internalSurveyInd: boolean;
  title: string;
}
